<div
  role="listbox"
  class="select select__single select--pristine select--bottom select--touched select__demo-spacing"
  [ngClass]="{ 'select--open': isOpen, 'select--error': error, 'select--disabled': disabled }"
>
  <div #trigger class="select__container" (click)="open()" (mousedown)="mousedown()">
    <div class="select__value-container">
      <div class="select__placeholder" *ngIf="!value || (multiple && !value.length)">
        {{ placeholder | translate }}
      </div>

      <div class="select__value" *ngIf="value && !multiple">
        <div [ngClass]="{ select__placeholder: disabled, 'select__value-label': !disabled, 'text-ellipsis': !disabled }" tooltip="{{'' + (isListOfObjects ? value[labelField] : value) | translate}}">
          {{ '' + (isListOfObjects ? value[labelField] : value) | translate }}
        </div>
      </div>

      <div class="select__value" *ngIf="value && multiple">
        <div class="select__value-label" *ngIf="value.length &&  value.length === flatItems.length">
          {{ 'core.label.allSelected' | translate }}
        </div>
        <div class="select__value-label" *ngIf="value.length !== flatItems.length">
          <span *ngFor="let v of value; index as i">
            {{ i > 0 ? ', ' : '' }}
            <span>
              {{ '' + (isListOfObjects ? v[labelField] : v) | translate }}
            </span>
          </span>
        </div>
      </div>
    </div>
    <span class="select__arrow-wrapper">
      <span class="select__arrow"></span>
    </span>
    <div class="select__icon">
      <svg-icon
        *ngIf="!isOpen"
        name="ico-caret-down-16"
        [svgStyle]="{ 'width.px': 16, 'height.px': 16, fill: 'currentColor' }"
      ></svg-icon>
      <svg-icon
        *ngIf="isOpen"
        name="ico-caret-up-16"
        [svgStyle]="{ 'width.px': 16, 'height.px': 16, fill: 'currentColor' }"
      >
      </svg-icon>
    </div>
  </div>

  <wfm-dropdown [adjustVerticalOverflow]="true" [disabled]="disabled" [(isOpen)]="isOpen"
                (isOpenChange)="isOpenChange()">
    <wfm-select-panel
      [style.min-width.px]="minWidth"
      [items]="items"
      [placeholder]="placeholder"
      [value]="value"
      [labelField]="labelField"
      [iconField]="iconField"
      [maxSelection]="maxSelection"
      [columns]="columns"
      [multiple]="multiple"
      [required]="required"
      [search]="search"
      [searchLabel]="searchLabel"
      [selectAllOption]="selectAllOption"
      [enableInternalSearch]="enableInternalSearch"
      [highlightSelected]="highlightSelected"
      [grouping]="grouping"
      (valueChange)="onValueChange($event)"
      (queryStr)="onQueryStr($event)"
      [translationEnabled]="translationEnabled"
    >
    </wfm-select-panel>
  </wfm-dropdown>
</div>
